import '../sigma/main'
import '../sigma/svg'

/**
  Component enables SVG renderer.
**/
function SigmaEnableSVG() { return null }

export default SigmaEnableSVG



// WEBPACK FOOTER //
// ./src/SigmaEnableSVG.js